import * as ActionType from "../actionType";
import { fetchPostCategoriesApi } from "../../services/page/postcategories";

const getPostCategoriesAction = () => {
  return async dispatch => {
    dispatchPostCategories(dispatch);
  };
};

const dispatchPostCategories = dispatch => {
  fetchPostCategoriesApi().then(data => {
    dispatch({
      type: ActionType.RECEIVE_POSTCATEGORIES,
      data
    });
  });
};

export { getPostCategoriesAction, dispatchPostCategories };


// WEBPACK FOOTER //
// ./src/actions/page/postcategories.js